import { useSelector } from "react-redux";
import { MODULE_KEY } from "./actions";
import { ACTION } from "../../util/utils";
import { formatDate } from "src/util/date";
import { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { DeleteOutlined } from "@mui/icons-material";
import Button from "src/components/common/Button/Button";

export default function filterColumns(updateData: any, setupdateData: any, filterValueData : any, setFilterValueData : any, deleteModal?: ((record: any) => void) | any) {
  const { data, loading } = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
  );
  const vendors: any | null | undefined = [];
  const collections: any | null | undefined = [];
  data?.map((row: any) => {
    vendors.push({ text: row.VendorName, value: row.VendorName });
  });

  data?.map((row: any) => {
    collections.push({ text: row.CollectionName, value: row.CollectionName })
  });

  let vendorName = vendors.filter(
    (ele: any, ind: any) =>
      ind === vendors.findIndex((elem: any) => elem.text === ele.text)
  );

  let collectionName = collections.filter(
    (ele: any, ind: any) =>
      ind === collections.findIndex((elem: any) => elem.text === ele.text)
  );

  const [collectionQuantityMap, setCollectionQuantityMap] = useState<{ [collectionName: string]: number }>({});

  useEffect(() => {
    const totals: { [collection: string]: number } = {};

    data.forEach((row: any, index: number) => {
      const collection = row.Collection;
      const updated = updateData.find((u: any) => u.index === index);
      const quantity = updated?.FinalPOQuantity ?? row.FinalPOQuantity ?? 0;

      if (!totals[collection]) {
        totals[collection] = 0;
      }
      totals[collection] += quantity;
    });

    setCollectionQuantityMap(totals);
  }, [data, updateData]);

  const columns = [
    {
      id: "ID",
      header: "ID",
      accessorKey: "ID1",
      size: 50,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "OFFICE NAME",
      accessorKey: "LocationName",
      size: 130,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "OFFICE NUMBER",
      accessorKey: "OfficeNum",
      size: 150,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "VENDOR",
      accessorKey: "Vendor",
      size: 160,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "COLLECTION",
      accessorKey: "Collection",
      size: 160,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "MODEL",
      accessorKey: "Model",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "COLOR",
      accessorKey: "ColorNumber",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "COLOR DESCRIPTION",
      accessorKey: "ColorDescription",
      size: 180,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "EYE SIZE",
      accessorKey: "EyeSize",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "UPC",
      accessorKey: "UPC",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "BRIDGE",
      accessorKey: "Bridge",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "TEMPLE",
      accessorKey: "Temple",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "SKU QUANTITY",
      accessorKey: "SKUQty",
      size: 135,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "FRAME TYPE",
      accessorKey: "FrameType",
      size: 140,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false
    },
    {
      header: "MED COST",
      accessorKey: "MEDCost",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },    
    {
      header: "RETAIL",
      accessorKey: "Retail",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "EFFECTIVE DATE",
      accessorKey: "EffectiveDate",
      size: 150,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell, column, table }: { cell: any, column: any, table: any }) => {
        const effectiveDate = cell.row?.original.EffectiveDate;
        const formattedDate = effectiveDate ? formatDate(effectiveDate) : "N/A";
        const globalFilterValue = table.getState().globalFilter;
        const filterValue = globalFilterValue || column.getFilterValue();

        if (filterValue && formattedDate.toLowerCase().includes(filterValue.toLowerCase())) {

          const regex = new RegExp(`(${filterValue})`, 'gi');
          const highlightedDate = formattedDate.replace(regex, '<span style="background-color: #FFD580;">$1</span>');

          return <span dangerouslySetInnerHTML={{ __html: highlightedDate }} />;
        }
        return formattedDate;
      },
    },
    {
      header: "ARRANGER QUANTITY",
      accessorKey: "ArrangerQty",
      size: 170,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false
    },
    {
      header: "COLLECTION ON HAND",
      accessorKey: "CollectionOnHand",
      size: 170,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false
    },
    {
      header: "PO NUMBER",
      accessorKey: "PONumber",
      size: 150,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "COLLECTION TOTAL ON HAND",
      accessorKey: "CollectionTotalOnHand",
      size: 150,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false
    },
    {
      header: "SUGGESTED PO QTY",
      accessorKey: "SuggestedPOQuantity",
      size: 160,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false
    },
    {
      header: "FINAL PO QUANTITY",
      accessorKey: "FinalPOQuantity",
      size: 150,
      enableColumnFilter: false,
      filterFn: 'contains',
      enableSorting: false,
      editingMode: "cell",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const rowIndex = row.index;
        const updatedRow = updateData.find((item: any) => item.index === rowIndex);
        const displayValue = updatedRow ? updatedRow.FinalPOQuantity : row.original?.FinalPOQuantity;
        return displayValue;
      },
      Edit: ({ cell, row }: { cell: any; row: any }) => {
        const rowIndex = row.index;
        const updatedItem = updateData.find((item: any) => item.index === rowIndex);
        const currentValue = updatedItem?.FinalPOQuantity ?? row.original.FinalPOQuantity ?? '';
        const [localValue, setLocalValue] = useState(currentValue);

        useEffect(() => {
          setLocalValue(currentValue);
        }, [currentValue]);

        return (
          <input
            type="text"
            min="0"
            value={localValue.toLocaleString('en-US')}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={() => {
              const rawValue = localValue.replace(/,/g, ''); 
              const value = parseFloat(rawValue);
            
              if (isNaN(value) || value < 0) return;
            
              const index = updateData.findIndex((item: any) => item.index === rowIndex);
              if (index === -1) {
                setupdateData((prev: any) => [
                  ...prev,
                  {
                    index: rowIndex,
                    FinalPOQuantity: value,
                  },
                ]);
              } else {
                setupdateData((prev: any) => {
                  const updated = [...prev];
                  updated[index].FinalPOQuantity = value;
                  return updated;
                });
              }
            
              setFilterValueData((prev: any[]) => {
                const updated = [...prev];
                updated[rowIndex] = {
                  ...updated[rowIndex],
                  FinalPOQuantity: value,
                };
                return updated;
              });
            }}
          />
        );
      },
    },
    {
      header: "FINAL PO COST",
      accessorKey: "FinalPOCost",
      size: 150,
      enableColumnFilter: false,
      filterFn: 'contains',
      enableSorting: false,
      enableEditing: false,
      Cell: ({ row }: { row: any }) => {
        const rowIndex = row.index;

        const updatedRow = updateData.find((item: any) => item.index === rowIndex);
        const quantity = updatedRow?.FinalPOQuantity ?? row.original?.FinalPOQuantity ?? 0;
        const medCost = row.original?.MEDCost ?? 0;
        const value = medCost * quantity;

        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      },
    },
    {
      header: "FINAL COLLECTION QUANTITY",
      accessorKey: "FinalCollectionQuantity",
      size: 150,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
      Cell: ({ row }: { row: any }) => {
        const collection = row.original?.Collection;
        const total = collectionQuantityMap[collection] ?? 0;

        return total.toLocaleString('en-US');
      },
    },
    {
      header: "COLLECTION ON HAND AFTER PO",
      accessorKey: "CollectionOnHandAfterPO",
      size: 150,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
      Cell: ({ row }: { row: any }) => {
        const original = row.original;
        const collection = original?.Collection;

        const onHand = typeof original?.CollectionTotalOnHand === 'number'
          ? original.CollectionTotalOnHand
          : 0;

        const finalQty = typeof collectionQuantityMap?.[collection] === 'number'
          ? collectionQuantityMap[collection]
          : 0;

        const total = onHand + finalQty;

        return total.toLocaleString('en-US');
      }
    },
    {
      header: "LAST 4W SALES",
      accessorKey: "LastFourWeekSales",
      size: 160,
      enableColumnFilter: false,
      filterFn: 'contains',
      enableSorting: false,
      enableEditing: false
    },
    {
      accessorKey: 'actions',
      header: 'ACTION',
      size: 150,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ cell, row }: { cell: any, row: any }) => {
        return (
          <>
            <div className="d-flex w-100">
              <Tooltip placement="top" title="Delete">
                <Button
                  icon={<DeleteOutlined sx={{ fontSize: 20, marginLeft: "10px", marginRight: "10px" }} />}
                  onClick={() => deleteModal(row.index)}
                  children={undefined}
                  danger={true}
                ></Button>
              </Tooltip>
            </div>
          </>
        );
      }
    }
  ];

  return { columns, data, loading, vendorName };
}
